import React, { useState } from 'react';
import { Button, Form, Input, Tabs, message } from 'antd';
import { GiftOutlined, LockOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../../services/api';
import { setToken, setUser } from '../../utils/auth';
import '../styles/h5.css';

interface H5LoginPageProps {
  onLogin: (token: string) => void;
}

const H5LoginPage: React.FC<H5LoginPageProps> = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (values: any) => {
    setLoading(true);
    try {
      const response = await authAPI.login(values);
      const { token, user } = response.data;
      setToken(token);
      setUser(user);
      onLogin(token);
      navigate('/h5', { replace: true });
    } catch (error: any) {
      message.error(error.response?.data?.error || '登录失败，请检查账号密码');
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (values: any) => {
    setLoading(true);
    try {
      const response = await authAPI.register(values);
      const { token, user } = response.data;
      setToken(token);
      setUser(user);
      message.success('注册成功');
      onLogin(token);
      navigate('/h5', { replace: true });
    } catch (error: any) {
      message.error(error.response?.data?.error || '注册失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h5-login-page">
      <section className="h5-login-hero">
        <div className="h5-login-hero-copy">
          <h1>英语作文批改系统</h1>
          <p>登录后继续今天的作文批改</p>
        </div>
        <div className="h5-login-doodle" aria-hidden="true" />
      </section>

      <section className="h5-panel h5-login-panel">
        <Tabs
          centered
          items={[
            {
              key: 'login',
              label: '登录',
              children: (
                <Form layout="vertical" size="large" onFinish={handleLogin}>
                  <Form.Item name="username" rules={[{ required: true, message: '请输入用户名' }]}>
                    <Input prefix={<UserOutlined />} placeholder="用户名" />
                  </Form.Item>
                  <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
                    <Input.Password prefix={<LockOutlined />} placeholder="密码" />
                  </Form.Item>
                  <Button type="primary" htmlType="submit" loading={loading} block>
                    登录
                  </Button>
                </Form>
              ),
            },
            {
              key: 'register',
              label: '注册',
              children: (
                <Form layout="vertical" size="large" onFinish={handleRegister}>
                  <Form.Item name="username" rules={[{ required: true, message: '请输入用户名' }]}>
                    <Input prefix={<UserOutlined />} placeholder="用户名" />
                  </Form.Item>
                  <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }, { min: 6, message: '至少 6 位' }]}>
                    <Input.Password prefix={<LockOutlined />} placeholder="密码" />
                  </Form.Item>
                  <Form.Item name="name" rules={[{ required: true, message: '请输入姓名' }]}>
                    <Input placeholder="姓名" />
                  </Form.Item>
                  <Form.Item name="invitation_code" rules={[{ required: true, message: '请输入邀请码' }]}>
                    <Input prefix={<GiftOutlined />} placeholder="邀请码" maxLength={12} />
                  </Form.Item>
                  <Button type="primary" htmlType="submit" loading={loading} block>
                    注册并进入
                  </Button>
                </Form>
              ),
            },
          ]}
        />
      </section>
    </div>
  );
};

export default H5LoginPage;
